export default __webpack_public_path__ + "static/media/quiz.9ed7f495.svg";